import React from 'react';
import styled from 'styled-components';
import { Theme } from 'hui/src/styled/theme';

/* eslint-disable */
const FormProgress = props => {
  const ProgressContainer = styled.div`
    justify-content: center;
    width: 100%;
    margin-left: 2em;
    margin-right: 2em;
    height: 6px;
    background-color: ${Theme.greyLight};
    border-radius: 100px;
  `;
  const ProgressBar = styled.div`
    width: ${props => props.progressValue};
    height: 6px;
    background-color: #00b9bd;
    border-radius: 100px;
  `;
  return (
    <ProgressContainer>
      <ProgressBar progressValue={props.progressValue} />
    </ProgressContainer>
  );
};
/* eslint-enable */
export default FormProgress;
